import { type ProgramWrite } from "../../zodios/apiDefinitions/api/programs";

/** What the program forms submit: the header fields plus the template's own fields. */
export interface ProgramFormValues {
  name: string;
  start_date: string;
  end_date?: string | null;
  [field: string]: unknown;
}

/** CUSTOM programs store their fields as `spec`; template programs store them as `ui_state`. */
export const toProgramFields = (
  { name, start_date, end_date, ...templateFields }: ProgramFormValues,
  templateType: string,
): Pick<ProgramWrite, "name" | "start_date" | "end_date" | "ui_state" | "spec"> =>
  templateType === "CUSTOM" ?
    { name, start_date, end_date, ui_state: {}, spec: templateFields }
  : { name, start_date, end_date, ui_state: templateFields, spec: {} };
